import React from "react";

// Chakra imports
import {Flex, Image} from "@chakra-ui/react";

// Custom components
import {HSeparator} from "components/separator/Separator";
import logo from "assets/img/layout/logo.svg";

export function SidebarBrand() {
    return (
        <Flex align='center' direction='column'>
            <Image src={logo} alt='ferienhaus.online' w='175px' mb='5'/>
            <HSeparator mb='20px'/>
        </Flex>
    );
}

export default SidebarBrand;
